import React from 'react';
import { NavLink } from 'react-router-dom';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';

var bnrimg = require('./../../images/s2/b2.jpg');

class Services_2 extends React.Component {
    render() {
        return (
            <>
                <Header />
                <div className="page-content">
                    <Banner
                        title="Clear Alerts. Calm Evacuation. Confident Response."
                        pagename="Public Address (PA) System"
                        bgimage={bnrimg}
                    />

                    <div className="section-full p-tb80 inner-page-padding">
                        <div className="container">
                            <div className="blog-single-wrap-width">
                                <div className="blog-post date-style-3 blog-detail text-black">
                                    <div className="mt-post-media clearfix m-b30">
                                        <ul className="grid-post">
                                            <li>
                                                <div className="portfolio-item">
                                                    <img
                                                        className="img-responsive"
                                                        src={require("./../../images/s2/b1.jpeg")}
                                                        alt="Public Address System"
                                                    />
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="mt-post-title">
                                        <h3 className="post-title font-weight-600">
                                            Public Address (PA) System
                                        </h3>
                                    </div>

                                    <div className="mt-post-text">
                                        <p><strong>"A calm voice during chaos is the first act of control."</strong></p>

                                        <p>
                                            A well-integrated Public Address (PA) system isn’t just an accessory—it's a critical link in your emergency response strategy. At <strong>I-Smart Engineering Works</strong>, we install advanced PA systems that work hand-in-hand with fire alarms to deliver real-time alerts, announcements, and evacuation commands clearly and efficiently.
                                        </p>

                                        <p>
                                            Our systems are engineered to perform in high-noise environments, ensuring every instruction is heard, even in the heat of emergency. Whether it’s a single building or a multi-zone campus, we bring scalable voice alarm solutions built on precision and military-grade discipline.
                                        </p>

                                        <h4 className="font-weight-600">What We Offer:</h4>
                                        <ul className="list-angle-right">
                                            <li>Fire-alarm linked PA system planning & deployment</li>
                                            <li>Multi-zone evacuation alerts and voice guidance</li>
                                            <li>High-decibel speaker & amplifier integration</li>
                                            <li>Auto/manual announcement systems</li>
                                            <li>Annual Maintenance Contracts (AMC) for 24/7 support</li>
                                        </ul>

                                        <blockquote className="bg-dark text-white author-quote">
                                            <h4 className="m-b0">
                                                “When communication fails, chaos begins. Our mission is clarity in every critical second.” <i className="fa fa-quote-right" />
                                            </h4>
                                            <div className="p-t15 text-white">
                                                <strong className="text-primary">Chief Kevin S., U.S. Navy Fire Marshal</strong>
                                                <span>Emergency Response Unit</span>
                                            </div>
                                        </blockquote>

                                        <p>
                                            We follow international safety standards and military-inspired reliability, because every second saved could mean lives saved. From commercial towers to public spaces, our PA systems speak loud and clear when it matters most.
                                        </p>

                                        {/* <div className="row">
                                            <div className="col-md-4 col-sm-4">
                                                <div className="mt-box m-b30">
                                                    <div className="mt-media">
                                                        <img
                                                            src={require("./../../images/blog/large-blog.jpg")}
                                                            alt="PA Installation Work"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4 col-sm-4">
                                                <div className="mt-box m-b30">
                                                    <div className="mt-media">
                                                        <img
                                                            src={require("./../../images/blog/large-blog2.jpg")}
                                                            alt="Fire Alarm Integration"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4 col-sm-4">
                                                <div className="mt-box m-b30">
                                                    <div className="mt-media">
                                                        <img
                                                            src={require("./../../images/blog/large-blog3.jpg")}
                                                            alt="Emergency Voice Alert"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}

                                        <p>
                                            <strong>Ready to upgrade your fire safety communication?</strong> We provide consultation, planning, installation, and after-sales support — all under one roof. Reach out today and let’s make your building audible and responsive.
                                        </p>
                                    </div>

                                    <div className="autor-post-tag-share bdr-t-1 bdr-solid bdr-gray p-t20">
                                        <div className="row">
                                            <div className="col-md-6 col-sm-6">
                                                <div className="widget widget_tag_cloud">
                                                    <h4 className="tagcloud">Tags</h4>
                                                    <div className="tagcloud">
                                                        <NavLink to={"#"}>PA System</NavLink>&nbsp;
                                                        <NavLink to={"#"}>Fire Alarm Communication</NavLink>&nbsp;
                                                        <NavLink to={"#"}>Evacuation Alerts</NavLink>&nbsp;
                                                        <NavLink to={"#"}>Voice Command Safety</NavLink>&nbsp;
                                                        <NavLink to={"#"}>AMC Support</NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <div className="mt-box">
                                                    <div className="clearfix">
                                                        <h4>Share this Post:</h4>
                                                        <div className="widget_social_inks">
                                                            <ul className="social-icons social-md social-square social-dark m-b0">
                                                                <li><NavLink to={"#"} className="fa fa-facebook" /></li>
                                                                <li><NavLink to={"#"} className="fa fa-twitter" /></li>
                                                                <li><NavLink to={"#"} className="fa fa-rss" /></li>
                                                                <li><NavLink to={"#"} className="fa fa-youtube" /></li>
                                                                <li><NavLink to={"#"} className="fa fa-instagram" /></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </>
        );
    }
}

export default Services_2;
